<template>
  <div class="process">
    <div class="process-container">
      <div class="title">
        流程简单
      </div>
      <div class="flow-row">
        <div class="row-box" v-for="(item, index) in flowList" :key="item.title">
          <div class="box-img">
            <img :src="item.img" alt="">
          </div>
          <div class="box-title">
            {{ item.title }}
          </div>
          <div class="box-num">
            {{ index + 1 }}
          </div>
          <div class="box-line"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'process',
    data () {
      return {
        flowList: [{
          title: '成为开发商',
          img: require('../image/f_ic_supplier.svg'),
        }, {
          title: '接收应用任务',
          img: require('../image/f_ic_accept.svg'),
        }, {
          title: '完成应用开发',
          img: require('../image/f_ic_finish.svg'),
        }, {
          title: '提交审核上线',
          img: require('../image/f_ic_online.svg'),
        }, {
          title: '运营监控',
          img: require('../image/f_ic_data.svg'),
        }],
      };
    },
  };
</script>

<style lang="less" src="../styles/process.less"></style>
